import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { LOGO_URL } from "@/api";
import { POLICY_BUNDLE_VERSION, policyPages } from "@/policies";

export default function PolicyPage() {
  const { policyKey } = useParams();
  const policy = policyPages[policyKey] || policyPages.protection;
  return (
    <main data-testid="policy-page" className="min-h-[calc(100vh-74px)] bg-[#F7F2EA] px-4 py-10 md:px-8 md:py-16">
      <section className="mx-auto max-w-4xl">
        <Link data-testid="policy-back-link" to="/" className="mb-6 inline-flex items-center gap-2 text-sm uppercase tracking-[0.16em] text-[#b84f3c]"><ArrowLeft size={16} /> Marketplace</Link>
        <img data-testid="policy-logo-image" src={LOGO_URL} alt="Bonsai Broker" className="mx-auto mb-8 h-24 w-24 rounded-full bg-white object-cover object-center shadow-lg shadow-black/10" />
        <p data-testid="policy-version" className="text-xs uppercase tracking-[0.22em] text-[#b84f3c]">Effective bundle {POLICY_BUNDLE_VERSION}</p>
        <h1 data-testid="policy-heading" className="mt-3 text-5xl font-light text-[#1A3626] md:text-6xl">{policy.title}</h1>
        <pre data-testid="policy-full-text" className="mt-8 whitespace-pre-wrap rounded-2xl border border-[#D5D1C4] bg-[#fffdf7] p-6 text-sm leading-7 text-[#26352b]">{policy.text}</pre>
      </section>
    </main>
  );
}